export function postAuthTokenToServiceWorker(token: string | undefined): void {
  navigator.serviceWorker.controller?.postMessage(`AuthToken:${token}`);
}
